import { fromHttpPromise } from 'pulse/adapters';
import { ResolverHttpClient } from 'pulse/resolvers';
import type { CrmObjectCoords } from './types';
import { batchScheduler } from 'batch-promise';
import {
  extractCrmObject,
  consumeEarlyCrmObject,
  makeCrmObjectBatchUrl,
} from './early';
import { CrmObjectsBatchResponse } from './types';

const scheduler = batchScheduler()
  .read<CrmObjectCoords & { httpClient: ResolverHttpClient }>()
  .identity(({ objectTypeId, objectId }) => `${objectTypeId}:${objectId}`)
  .partition(({ objectTypeId }) => objectTypeId)
  .execute(async (calls, objectTypeId) => {
    const callsArray = Object.values(calls);

    return callsArray[0].httpClient.get<CrmObjectsBatchResponse>(
      await makeCrmObjectBatchUrl(objectTypeId, callsArray)
    );
  })
  .extract(extractCrmObject)
  .chunkSize(25)
  .immediate();

const fetchCrmObject = (
  httpClient: ResolverHttpClient,
  coords: CrmObjectCoords
) =>
  consumeEarlyCrmObject(coords).catch(() =>
    scheduler.queue({ httpClient, ...coords })
  );

export const defaultCrmObjectResolver = fromHttpPromise(
  'crmObjectResolver',
  fetchCrmObject
);

export const __TEST_ONLY_abortCrmObjectLiteScheduler = () => scheduler.abort();
